<template>
  <component :is="dashboardComponent"/>
</template>

<script>
import { mapActions } from 'vuex'
import { AdminDashboard, ClientDashboard, TalentDashboard, ManagerDashboard, InternDashboard } from 'components/dashboards'

export default {
  components: {
    AdminDashboard,
    InternDashboard,
    ClientDashboard,
    TalentDashboard,
    ManagerDashboard
  },

  computed: {
    dashboardComponent () {
      if (this.$userIsAdmin) {
        return 'admin-dashboard'
      } else if (this.$userIsTalent) {
        return 'talent-dashboard'
      } else if (this.$userIsClient) {
        return 'client-dashboard'
      } else if (this.$userIsManager) {
        return 'manager-dashboard'
      } else if (this.$userIsIntern) {
        return 'intern-dashboard'
      }
    }
  },

  created () {
    this.getLists()
  },

  methods: mapActions('dashboard', ['getLists'])
}
</script>
